<div class="spinner-wrapper"
     [ngClass]="{'fullscreen': fullscreen, 'opaque': opaque}">
  <mat-spinner [diameter]="size"></mat-spinner>
</div>
